import { CREATE_COMPANY_METRICS } from '../constants/actionTypes';

const initialState = {
  metricsSummation: {}
};

// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COMPANY_METRICS.SUCCESS:
      return {
        ...state,
        metricsSummation: action.obj
      };
    default:
      return state;
  }
};
